import ReactGA from 'react-ga4';
import { ENABLE_ANALYTICS } from './env';

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || '';

export const initGA = () => {
  console.log('Initializing GA with tracking ID:', TRACKING_ID);
  console.log('Analytics enabled:', ENABLE_ANALYTICS);
  
  if (ENABLE_ANALYTICS && TRACKING_ID) {
    ReactGA.initialize(TRACKING_ID);
    console.log('GA initialized successfully');
  } else {
    console.warn('GA initialization skipped:', { ENABLE_ANALYTICS, TRACKING_ID });
  }
};

export const logPageView = (path: string) => {
  if (ENABLE_ANALYTICS && TRACKING_ID) {
    console.log('Logging page view:', path);
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

export const logEvent = (category: string, action: string, label?: string) => {
  if (ENABLE_ANALYTICS && TRACKING_ID) {
    console.log('Logging event:', { category, action, label });
    ReactGA.event({
      category,
      action,
      label
    });
  }
};
